import { render } from "./featured-collection.vue?vue&type=template&id=235b9460"
import script from "./featured-collection.vue?vue&type=script&lang=js"
export * from "./featured-collection.vue?vue&type=script&lang=js"

import "./featured-collection.vue?vue&type=style&index=0&id=235b9460&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__